<template>
  <div v-if="user" class="q-pa-sm q-body-1">
    <user-section-info :user="user" :activeTeam="activeTeam"></user-section-info>

    <user-section-popover
      :teams="teams"
      :activeTeam="activeTeam"
    ></user-section-popover>
  </div>
</template>

<script>
  import UserSectionInfo from './UserSectionInfo.vue'
  import UserSectionPopover from './UserSectionPopover.vue'
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'user',
        'activeTeam',
        'teams'
      ])
    },

    components: {
      UserSectionInfo,
      UserSectionPopover
    }
  }
</script>
